<template>
  <div>
    <Container>
      <SectionHeader title="About us" />
    </Container>
    <SocialLinks />
  </div>
</template>
<script>
export default {
  components: {
    SocialLinks: () =>
      import(
        /* webpackChunkName: "home-shared-social-links" */ "./shared/socialLinks"
      ),
  },
};
</script>